import { getappperAuthority } from "@/port/schoolInstrument/appConfig";
import { apiGetmiddleuserbyid, deletelastrecentdata } from '@/port/admins/instrument'
import { getwebsiteapproval, getapprovaldashboard } from '@/port/pages/webSite.js'
import { getfilecontent } from '@/port/admins/ai'
import { outhreflogin, getaccesstoken } from '@/port/pages/login'
import { filterSymbol } from '@/api/instrumentControl'
import { isValidateapprovaltimeswitch } from '@/components/schoolInstrument/mixins/utils'
import qs from 'qs'
import { goAppId } from '@/util/util'
import { getCustomVal } from '@/util/customData'
import { getapiuserlist } from "@/port/clientSide/multipleChoice";
import { getInsideScreenParam, getOtherLinked } from './config'
import { generateTime, generateTime10, generateTime60 } from "@/api/utils";
import { markdownToHtml, markdownToText } from '@/api/global'
import { cloneDeep } from "lodash";

const purviewObj = {
    11: 'approvalid',
    1: 'myreportformid',
    2: 'myreportformid',
    3: 'myreportformid',
    4: 'myreportformid',
    5: 'myreportformid',
    27: 'myreportformid',
    6: 'scopeid',
    7: 'reportFormid',
    8: 'uncompleteid',
    12: 'approvalid',
    14: 'reportFormid',
    16: 'reportFormid',
    18: 'reportFormid',
    28: 'reportFormid',
    15: 'myreportformid',
    17: 'myreportformid',
    13: 'myreportformid',
    23: 'myreportformid',
    24: 'myreportformid',
}

const time30 = generateTime()
const time60 = generateTime60()
const time10 = generateTime10()
const TIME_10_30_60 = {
    10: time10,
    30: time30,
    60: time60
}

export default {
    data() {
        return {
            isShowEidtUser: false,
            editUserInfoKey: {},
            userInfo: {},
            openfunction: {}
        }
    },
    methods: {
        async goEditUserInfo(row, config) {
            const { editFeild = '', editFeildList } = config
            const title = editFeild.split('_')[0]
            let data = []
            if (title === '申请人') {
                // 联系人先不管
                data = [{
                    userId: row.userId
                }]
            } else {
                data = row[title] || []
            }
            if (data.length !== 1) {
                this.$message.warning('无法修改')
                return
            }
            if (editFeild) {
                if (Object.keys(editFeildList).length === 0) {
                    return this.$message.warning('未选择可编辑字段')
                } else {
                    const res = await getapiuserlist({ userids: data[0].userId, curpage: 0, pagesize: 1 })
                    if (res.code === 0) {
                        this.userInfo = res.data[0]
                        this.editUserInfoKey = editFeildList
                        this.isShowEidtUser = true
                    } else {
                        this.$message.warning(res.msg)
                    }
                }
            } else {
                console.log('给提示');
            }
        },
        async getAppInfo(id, type = 1) {
            let fn = getwebsiteapproval
            let _par = {
                skey: this.skey,
            }
            if (type === 5) {
                fn = getapprovaldashboard
                _par.approvalDashboardId = id
            } else {
                _par.approvalId = id
            }
            const res = await fn(_par)
            if (res.code === 0) {
                if (res.data.status === 0) {
                    return false
                }
                return res.data.openfunction
            }
        },
        async getWebsiteUserInfo(iId) {
            if (iId !== 11) return
            const skey = this.$route.params.skey || this.$route.query.skey
            if (!skey) return
            let accesstoken = ''
            for (let i = 0; i < 6; i++) {
                accesstoken += Math.floor(Math.random() * 10);
            }
            const { data, code } = await outhreflogin({ skey, accesstoken })
            if (code === 0) {
                let date = {
                    schoolId: data.listschool[0].schoolId,
                    openId: data.userId,
                    accesstoken: accesstoken
                }
                const res = await getaccesstoken(date)
                if (res.code === 0) {
                    const user = res.data
                    localStorage.setItem('visitorUser', JSON.stringify(user))
                }
            }
        },
        openOutside(info) {
            console.log(info, 'ddddddddddddd')
            const insideInfo = info.insideInfo
            const { open, popUps, url } = insideInfo
            if (!url) {
                this.$message.error('未配置url')
                return
            }
            if (open === 2 || open === 5) {
                const obj = {
                    2: 'dialog',
                    3: 'new',
                    4: 'old',
                    5: 'rightdia'
                }
                this.dialogInfo = {
                    isVisible: true,
                    dialogName: '',
                    dialogWidth: popUps.w + 'px',
                    dialogHeight: popUps.h + 'px',
                    openType: obj[open],
                    customSize: popUps.customSize,
                    diaSize: popUps.diaSize,
                    dialogUrl: url,
                    openfunction: this.openfunction
                }
                this.$emit('open-appDialog', this.dialogInfo)
            } else if (open === 3) {
                window.open(url)
            } else if (open === 4) {
                window.replace(url)
            }
        },
        dialogClose() { },
        async dealInside(row, config, listValue = []) {
            // 处理选择站内应用
            // datatype 1表单 5仪表盘 7 报表应用
            const item = JSON.parse(JSON.stringify(config))
            
            const user = localStorage.getItem('user')
            const type = 'detailed'
            item.link = item.link || 2
            item.value = row
            item.listValue = listValue
            // ai直接传入搜索结果
            if (config.channel && config.channel === 'ai') {
                item.value = config.value
            } else if (config.channel && config.channel === 'appAi') {
                if(item.linked && item.linked.length > 0){
                    const linkedFields = item.linked;
                    linkedFields.forEach(linkedField => {
                        const valueKey = `${linkedField.title}_${linkedField.type}`;
                        if (Object.prototype.hasOwnProperty.call(item.value, valueKey)) {
                            linkedField.value = item.value[valueKey];
                        }
                    });
                }
            }
            console.log("item11==", item);
            if (item.appIid === 11 && item.datatype === 1 && item.insideAdd && ((item.insideAdd.customize && item.insideAdd.customize.length !== 0) || (item.insideAdd.from && item.insideAdd.from.length !== 0))) {
                // 表单
                const info = {
                    config: item.insideAdd,
                    row: row,
                    approvalId: this.approvalId || (this.approval && this.approval.approvalId),
                }
                localStorage.setItem('insideAdd', JSON.stringify(info))
            }
            if (this.skey && !user) {
                const flag = await this.getAppInfo(item.appid, item.datatype)
                if (!flag) {
                    this.$message.error('该应用未开放')
                    return
                }
                if ((flag.loginstatus === 1 && item.appIid === 11 && flag.loginaction === 0)) {
                    // 填写前注册 或者是 打开了查询登录
                    this.$emit('open-login', { row, item }, this.elId)
                    return
                } else if (flag.loginstatus === 1 && item.appIid === 11 && flag.loginaction === 1) {
                    // 提交前注册
                    await this.getWebsiteUserInfo(item.appIid)
                    this.openfunction = flag
                } else if (flag.searchstatus === 1) {
                    this.$emit('open-login', { row, item }, this.elId)
                    return
                } else if (flag.loginstatus === 0 && item.appIid === 11) {
                    await this.getWebsiteUserInfo(item.appIid)
                }
            }
            const iId = item.appIid
            const validateList = [11, 1, 7, 6]
            if (validateList.indexOf(iId) !== -1 && item.datatype === 1) {
                const obj = {
                    11: 1,
                    1: 2,
                    7: 3,
                    6: 4
                }
                const payload = { type: obj[iId], approvalId: item.appid }
                const upaceId = this.isUpace ? (this.$route.query.upaceid || localStorage.getItem('upaceid')) : undefined
                const flag = await isValidateapprovaltimeswitch(payload, upaceId)
                if (flag) return
            }
            // 只有选择了一条数据才可以点击
            if (item.datatype !== 2 && item.link === 2 && !this.skey && !Number.isNaN(Number(item.appIid))) {
                const getPermissions = await this.getApper(item)
                const permissions = purviewObj[item.appIid]
                if (getPermissions.code === 0 && Array.isArray(getPermissions.data)) {
                    const pInd = getPermissions.data.findIndex(its => its.key === permissions)
                    if (pInd === -1) {
                        this.$message.warning('您无权限查阅该页面!')
                        return
                    }
                }
            }
            if (item.datatype === 1 && (item.appIid === 18 || item.appIid === 17)) {
                this.delLastrecentdata(item, type)
                return
            }
            if (item.open === 3) {
                // 当前页面
                const str = await this.getOpenUrl(item, type)
                const url = window.location.origin
                window.open((item.link !== 3 ? url : '') + str, '_blank')
            } else if (item.open === 2 || item.open === 5) {
                // 弹窗
                // 如果是站内，并选择了应用-提交
                if (item.link === 2 && item.datatype !== 5 && item.datatype !== 7 && item.appIid === 11) {                                        
                    const str = await this.getField(item, type)
                    const popUps = {
                        ...item.popUps,
                        open: item.open
                    }
                    this.openAppInitiate({ ...str, iId: item.appIid, id: item.id, popUps, openfunction: this.openfunction, pageType: config.pageType || '' })
                } else {
                    const str = await this.getOpenUrl(item, type)
                    const org = {
                        15: true, // 打开个人最新数据
                        16: true, // 打开全部最新数据
                        23: true, // 打开个人最新数据
                        24: true, // 打开全部最新数据
                        13: true, // 修改个人最新数据
                        14: true // 修改全部最新数据
                    }
                    if (org[item.appIid]) {
                        const popUps = {
                            ...item.popUps,
                            open: item.open
                        }
                        this.openAppInitiate({ approvalId: item.appid, name: item.name, search: str, iId: item.appIid, datatype: item.datatype, id: item.id, popUps, pageType: config.pageType || '' })
                    } else {
                        const obj = {
                            2: 'dialog',
                            3: 'new',
                            4: 'old',
                            5: 'rightdia'
                        }
                        this.dialogInfo = {
                            isVisible: true,
                            dialogName: '',
                            dialogWidth: item.popUps.w + 'px',
                            dialogHeight: item.popUps.h + 'px',
                            openType: obj[item.open],
                            customSize: item.popUps.customSize,
                            diaSize: item.popUps.diaSize,
                            dialogUrl: str,
                            openfunction: this.openfunction
                        }
                        if(item.channel && item.channel === 'appAi'){
                            this.openAppDialog(this.dialogInfo)
                            
                        }
                        this.$emit('open-appDialog', this.dialogInfo)
                    }
                }
            } else if (item.open === 4) {
                // 新页面
                const str = await this.getOpenUrl(item, type)
                window.location.href = str
            }
        },
        async getApper(item) {
            const obj = {
                appid: item.appid,
                datatype: item.datatype
            }
            // 从空间进入，需要传空间id
            if (this.isSpace) {
                let spaceId = typeof (this.$route.query.spaceid) !== 'undefined' ? this.$route.query.spaceid : localStorage.getItem('spaceid')
                obj.spaceid = spaceId;
            }
            else if (this.isUpace) {
                let upaceId = typeof (this.$route.query.upaceId) !== 'undefined' ? this.$route.query.upaceId : localStorage.getItem('upaceId')
                obj.upaceid = upaceId;
            }
            if (this.$route.query.spaceid) {
                obj.spaceid = this.$route.query.spaceid
            }
            else if (this.$route.query.upaceid || localStorage.getItem('upaceid')) {
                obj.upaceid = this.$route.query.upaceid || localStorage.getItem('upaceid')
            }
            const res = await getappperAuthority(obj).catch(err => { console.log(err) })
            if (item.datatype !== 2) {
                return res
            }
            if (res.code === 0 && res.data.per) {
                return res.data.pcUrl
            } else {
                this.$message.warning(res.msg || '暂无权限!')
            }
            return false
        },
        async getTime(str, format) {
            if (!str || str === 0) return ''
            if (!format) return str
            const date = new Date(str)
            const obs = {
                YYYY: date.getFullYear(),
                MM: date.getMonth() + 1,
                DD: date.getDate()
            }
            return format.split('/').map(item => obs[item]).join('/')
        },
        // 删除对标数据
        delLastrecentdata(item, type) {
            this.$confirm('确定要删除？', '', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async () => {
                // 删除
                const str = await this.getField(item, type)
                const obj = {
                    type: item.appIid === 18 ? 0 : 1,
                    approvalId: str.approvalId
                }
                if (str.search) {
                    obj.query = {}
                    for (const s in str.search) {
                        // 空数据不管
                        if (str.search[s] || str.search[s] === 0) {
                            const val = str.search[s]
                            if (Array.isArray(val)) {
                                obj.query[s] = val
                            } else {
                                obj.query[s] = [val]
                            }
                            // 做一次空置去除
                            obj.query[s] = obj.query[s].filter(its => its || its === 0)
                        }
                    }
                }
                if (obj.query) obj.query = JSON.stringify(obj.query)
                // console.log('拼接完毕', obj)
                const res = await deletelastrecentdata(obj).catch(err => { console.log('删除错误', err) })
                if (res.code === 0) {
                    //  TODO 刷新列表
                    this.$emit('updateTable', {})
                    this.$message({
                        type: 'success',
                        message: '删除成功!'
                    });
                } else {
                    this.$message({
                        type: 'error',
                        message: res.msg
                    });
                }
            })
        },
        // 获取当前需要打开的 url
        async getOpenUrl(item, type) {
            console.log('当前要跳转的', item, type)
            let str = item.url
            const search = {}
            switch (item.link) {
                case 1:
                    break
                case 2:
                    if (type === 'detailed') {
                        if (item.datatype === 7) {
                            // 7 是报表应用
                            str = `/clientSide/reportView/?reportId=${item.appid}`
                        } else if (item.datatype === 8) {
                            // 8 是 ai小易
                            str = `/chat?aiModelId=${item.appid}`
                        } else if (item.datatype === 5) {
                            // 5 是 仪表盘的
                            str = `/clientSide/instrument/instrument?dataReportId=${item.appid}&showSearch=true`
                            if (item.open === 4) str += 'navShow=true'
                        } else if (item.datatype === 2 && !this.skey) {
                            str = await this.getApper(item)
                            if (str === false) return false
                        } else {
                            const obs = {
                                approvalId: item.appid,
                                iId: item.appIid,
                                source: 'user',
                                name: item.appName,
                                navShow: false
                            }
                            obs[goAppId[item.appIid]] = item.appIid
                            // 提交统计走另外的 url
                            if (item.appIid === 8) {
                                str = `/clientSide/workbench/CycleFillingSetting/CycleFillingSetting?${qs.stringify(obs)}`
                            } else if (item.appIid === 27 || item.appIid === 28) {
                                str = `/clientSide/workbench/TMbulkImport?${qs.stringify(obs)}&bulkImportMutat=${item.appIid === 28}`
                            } else {
                                str = `/clientSide/application?${qs.stringify(obs)}`
                            }
                        }
                    } else if (item.datatype && item.datatype === 2 && !this.skey) {
                        str = await this.getApper(item)
                        if (str === false) {
                            return false
                        }
                    } else if (item.datatype && item.datatype === 8) {
                        str = `/chat?aiModelId=${item.appid}`
                    } else {
                        str = `/clientSide/application?approvalId=${item.appid}&source=user&name=${item.appName}`
                        if (item.open === 2 || item.open === 5) str += '&navShow=false'
                    }
                    break
            }
            // 不是链接才去找配置，是链接直接计算值
            if (item.link === 1) {
                // 根据 id 找到对应所有配置
                const i = this.layout.findIndex(its => its.i === item.id)
                if (i !== -1) {
                    const datas = this.layout[i]
                    console.log('查找对应配置', datas)
                    // 当前规则只有表内组建才支持
                    if (datas.rules && datas.link === 1) {
                        //- 外置筛选组件的筛选规则
                        search.rules = datas.rules;
                    }
                    // 本表数据参数
                    if (datas.relevanceRules) {
                        //- 表单关联表单的筛选规则
                        search.relevanceRules = datas.relevanceRules;
                    }
                }

                if (search.rules || search.relevanceRules) {
                    str += `&search=${JSON.stringify(search)}`
                }
            } else if (item.link === 2) {
                // 应用的话单独配置
                console.log('应用的单独配置1', item, item.linked)
                let obs = {}
                let paramsLists = []
                if (item.listValue && item.listValue.length > 0) {
                    let date = []
                    for (const ele of item.listValue) {
                        const data = await this.getObs(item, ele)
                        date.push(data.obs)
                        paramsLists = paramsLists.concat(data.paramsLists)
                    }
                    obs = date
                } else {
                    const data = await this.getObs(item, item.value)
                    console.log("data==",data);
                    
                    obs = data.obs
                    paramsLists = data.paramsLists || []
                }
                if ([27, 28].includes(item.appIid) && obs) {
                    // 处理导入的默认值覆盖
                    const val = Array.isArray(obs) ? obs[0] || {} : obs
                    localStorage.setItem('TMbulkImportObs', JSON.stringify([val]))
                    const defaultObj = this.getDefaultObj(item, val) || {}

                    if (Object.keys(defaultObj).length > 0) {
                        localStorage.setItem('defaultDataObs', JSON.stringify(defaultObj))
                    }
                }
                if(item.channel && item.channel === 'appAi'){
                    str += '&channel=appAi'
                    // 如果传参有值，则直接赋值
                    if(item.linked && item.linked.length > 0){
                        let linkedFormdata = {};    
                        item.linked.forEach(linkedField => {
                            if(linkedField.value){
                                const matchingRule = linkedField.FormList.find(rule => rule.name === linkedField.conditionValue);
                                linkedFormdata[matchingRule.title + '_' + matchingRule.type] = linkedField.value;
                            }
                        });
                        str += `&customData=${JSON.stringify(linkedFormdata)}`
                    }
                }
                if (JSON.stringify(obs) !== '{}' && ![27, 28].includes(item.appIid)) {
                    str += `&search=${JSON.stringify(obs)}`
                }
                if (paramsLists.length > 0) {
                    str += `&paramsList=${JSON.stringify(paramsLists)}`
                }
                console.log('应用的单独配置返回', str, obs, item, item.datatype === 2)
            } else {
                const obs = {}
                for (const i of item.customize) {
                    let val = item.value[i.title || i.name]
                    if (i.type === 'relation-user' && typeof val === "object") {
                        if (i.format === 'userId' || i.format === 'realname') {
                            val = Array.isArray(val) ? val.map(its => its[i.format]).join(',') : val[i.format]
                        } else {
                            const user = await this.getUserInfo(val.userId)
                            val = user[i.format]
                        }
                    } else if (i.type === 'date') {
                        val = await this.getTime(val, i.format)
                    }
                    if (i.parameter) {
                        obs[i.parameter] = val
                    } else {
                        if (item.link !== 3) {
                            const typeI = i.FormList.findIndex(its => {
                                return its.name === i.conditionValue || `${its.name}_${its.type2}` === i.conditionValue
                            })

                            const typeObj = i.FormList[typeI]

                            const type = typeObj.type === 'Sizer' ? typeObj.i : typeObj.title + '_' + typeObj.type
                            obs[type] = val || ''
                        } else {
                            obs[i.title + '_' + i.type] = val
                        }
                    }
                }
                const obsStr = qs.stringify(obs)
                let strName = '?'
                if (item.link === 3 && item.url && item.url.includes('?')) strName = '&'
                if (obsStr) str += (strName + obsStr)
            }
            if (this.$route.query.upaceid) {
                str += '&upaceid=' + this.$route.query.upaceid
            }
            return str
        },
        async importLinked(info, dataList, chooseField = [], AiDropData) {
            chooseField = cloneDeep(chooseField)
            const allInCustomInfo = info.allInCustomInfo
            let isCustomHeader = false
            let customHeaderList = []
            console.log(allInCustomInfo, 'allInCustomInfo')
            if (allInCustomInfo) {
                if (allInCustomInfo.importType === 'table') {
                    if (info.allInCustomInfo.valueKey === 0) {
                        chooseField.push({ title: '单号', type: 'text' })
                    } else {
                        info.allInCustomInfo.valueSearchList.forEach(item => {
                            const [title, type] = item.split('_')
                            chooseField.push({ title, type })
                        })
                    }
                }
                // 处理列转行的数据传参
                if (allInCustomInfo.importHeaderType === 'custom') {
                  isCustomHeader = true
                  customHeaderList = allInCustomInfo.customHeaderInfo.rowHeadName.split(',')
                }
            }

            if (info.insideInfo && info.insideInfo.linked) {
                let date = []

                if (AiDropData) {
                    date = AiDropData
                } else {
                    if (!dataList) {
                        dataList = cloneDeep(this.multipleSelection)
                    }
                    if (dataList.length > 0) {
                        for (const ele of dataList) {
                            const data = await this.getObs(info.insideInfo, ele)
                            const obj = {}
                            chooseField.forEach(item => {
                                obj[`${item.title}_${item.type}`] = ele[item.title]
                            })
                            if (isCustomHeader) {
                              const eleKeys = Object.keys(ele)
                              customHeaderList.forEach(item => {
                                const key = eleKeys.find(iten => { return iten.search(`.${item}`) !== -1 && iten.search('approving_id') === -1 })
                                if (key) {
                                  obj[item] = ele[key]
                                }
                              })
                            }
                            date.push({ ...obj, ...data.obs })
                        }
                    } else {
                        const data = await this.getObs(info.insideInfo, {})
                        date.push(data.obs)
                    }
                }
                if (date.length > 0) {
                    if (chooseField.length === 0) {
                        const defaultObj = this.getDefaultObj(info.insideInfo, date[0]) || {}
                        if (Object.keys(defaultObj).length > 0) {
                            localStorage.setItem('defaultDataObs', JSON.stringify(defaultObj))
                        }
                    }
                    localStorage.setItem('TMbulkImportObs', JSON.stringify(date))
                }
            }
        },
        // 获取表单导入覆盖默认值的对象
        getDefaultObj(info, data) {
            const defaultObj = {}
            if (info && info.linked) {
                info.linked.forEach(link => {
                    if (link.datatype === 'custom') {
                        const filed = link.FormList.find(iten => { return link.conditionValue === iten.name })
                        if (filed) {
                            const key = `${filed.title}_${filed.type}`
                            if (filed.datatype !== 'custom' && data[key]) {
                                defaultObj[key] = data[key]
                            }
                        }
                    }
                })
            }
            return defaultObj
        },
        async getObs(item, value) {
            let obs = {}
            // const screenLinked = item.linked.filter(f => f.orgName === 'screen')
            // const filedLinked = item.linked.filter(f => f.orgName !== 'screen')
            const screenLinked = []
            const filedLinked = []
            const otherLinked = []
            for (const i of item.linked) {
                if (i.orgName === 'screen') {
                    screenLinked.push(i)
                } else if (i.orgName === 'filed' || i.orgName === undefined) {
                    filedLinked.push(i)
                } else {
                    otherLinked.push(i)
                }
            }
            if (otherLinked.length !== 0) {
                const obj = getOtherLinked({ linked: otherLinked, currentOrg: this.currentOrg, currentUser: this.currentUser })
                obs = { ...obs, ...obj }
            }
            if (screenLinked.length !== 0) {
                const screens = (this.screenRef && this.screenRef.length > 0 ? this.screenRef : this.$refs.screenRef) || []
                if (this.otherToolScreenRef && this.otherToolScreenRef.length > 0) {
                  screens.push(...this.otherToolScreenRef)
                }
                const currentOrg = this.currentOrg
                const customData = this.customData
                obs = { ...obs, ...getInsideScreenParam({ screenLinked, screens, currentOrg, customData, orgList: this.orgList }) }
            }
            
            const paramsLists = []
            for (const key in obs) {
                if (key.includes('_custom')) {
                    const obj = {
                        name: key.split('_')[0],
                        value: obs[key]
                    }
                    paramsLists.push(obj)
                    delete obs[key]
                }
            }
            for (const i of filedLinked) {
                let val = ''
                if (i.datatype === 'custom') {
                    // 自定义的变量
                    val = getCustomVal(i)
                } else {                    
                    val = value[i.title || i.name] || value[i.title] || value[i.name]
                    // 如果配置解析数据，缓存它的值(解析数据的值可能超过url传参的限制)
                    if(i.title === 'data-analysis'){
                        val = 'dataAnalysisStorage'
                        localStorage.setItem('dataAnalysisStorage', value[i.title])
                    }
                    else if(item.channel && item.channel === 'appAi'){
                        // 配置了文件解析并打开
                        if (i.type === 'file') {console.log("aaaqq===",i.type,i.value),i.value.length;
                            for (const itemSub of this.ruleList) {
                                if (itemSub.type === 'file' && itemSub.title === i.title && itemSub.analysis) {
                                  console.log("aaaqq===", itemSub.type, i.value);
                                  
                                  if (i.value && i.value.length > 0) {
                                    let fileVal = '';
                                    
                                    for (const file of i.value) {
                                      if (file.response) {
                                        const fileName = file.response.replace(/^\/userfiles\//, '');
                                        console.log("fileName==", fileName, this.ruleList);
                                        
                                        const fileContent = await this.getfileCont(fileName);
                                        // 只有当 fileContent 不是 false 时才累加
                                        if (fileContent !== false) {
                                            fileVal += fileContent;
                                        }
                                        else return
                                      }
                                    }
                                    
                                    val = 'fileAnalysisStorage';
                                    localStorage.setItem('fileAnalysisStorage', fileVal);
                                  }
                                }
                            }
                        }
                        else{
                            val = value[i.title + '_' + i.type]
                        }
                    }
                    
                }
                if (i.type === 'relation-user') {
                    // 如果是发起相关，直接返回数据
                    if (typeof val === "object") {
                        if (item.appIid === 12 || item.appIid === 11) {
                            // TODO
                        } else {
                            if (i.format) {
                                if (i.format === 'userId' || i.format === 'realname') {
                                    const s = val
                                    if (Array.isArray(s)) {
                                        val = s.map(its => its[i.format])
                                    } else {
                                        val = val[i.format]
                                    }
                                } else {
                                    const userArr = val
                                    if (Array.isArray(userArr)) {
                                        const userArrFromat = []
                                        for (const e of userArr) {
                                            console.log('联系人查询', e)
                                            const user = await this.getUserInfo(e.userId)
                                            userArrFromat.push(user[i.format || 'realname'])
                                        }
                                        val = userArrFromat
                                        // val = userArrFromat.join(',')
                                    } else {
                                        const user = await this.getUserInfo(val.userId)
                                        val = user[i.format]
                                    }
                                }
                            }
                        }
                    } else if (i.title === '申请人' && i.name === '申请人') {
                        val = [{
                            realname: val,
                            userId: value.userId
                        }]
                    }
                } else if (i.type === 'date') {
                    val = await this.getTime(val, i.format)
                } else if (i.fatherType && i.fatherType.includes('ready-widget')) {
                    val = value[filterSymbol(i.title)]
                    if (val && i.type === 'dates') val = val.split(',')
                }
                const typeI = i.FormList.findIndex(its => {
                    let isCustom = false
                    if (i.conditionValue && i.conditionValue.search('custom') !== -1) {
                        isCustom = true
                    }
                    const name = i.conditionValue && i.conditionValue.search('custom') !== -1 ? i.conditionValue.split('_')[0] : i.conditionValue
                    return isCustom ? its.name === name && its.datatype === 'custom' : its.name === name
                })
                const typeObj = i.FormList[typeI]
                if (typeObj.datatype === 'custom') {
                    if (item.datatype === 7 && i.datatype !== 'custom' && Array.isArray(item.detailValue) && item.detailValue.length > 0) {
                        let valList = []
                        item.detailValue.forEach(iter => {
                            const data = iter[i.title || i.name] || iter[i.title] || iter[i.name]
                            Array.isArray(data) ? valList.push(...data) : valList.push(data)
                        })
                        valList = valList.filter(iter => { return iter || iter === 0 })
                        paramsLists.push({ name: typeObj.name, value: valList.length > 0 ? valList : '' })
                    } else {
                        paramsLists.push({ name: typeObj.name, value: val || '' })
                    }
                } else {
                    const type = typeObj.type === 'Sizer' ? typeObj.i : typeObj.title + '_' + typeObj.type
                    obs[type] = val || ''
                }
            }
            for (const i of item.customize) {
                let val = value[i.title || i.name]
                if (i.type === 'relation-user' && typeof val === "object") {
                    if (i.format) {
                        if (i.format === 'userId' || i.format === 'realname') {
                            val = val[i.format]
                        } else {
                            const user = await this.getUserInfo(val.userId)
                            val = user[i.format]
                        }
                    }
                } else if (i.type === 'date') {
                    val = await this.getTime(val, i.format)
                } else if (i.fatherType && i.fatherType.includes('ready-widget')) {
                    val = value[filterSymbol(i.title)]
                    if (val && i.type === 'dates') val = val.split(',')
                }
                if (item.datatype === 5) {
                    // 仪表盘另外算
                    let types = ''
                    const formItem = i.FormList[i.index]
                    if (formItem && formItem.datatype !== 'custom') {
                        types = formItem.i
                        if (obs[types]) {
                            const vals = Array.isArray(obs[types]) ? obs[types].push(val) : [obs[types], val]
                            obs[types] = vals
                        } else {
                            obs[types] = i.value
                        }
                    } else {
                        const typeObj = i.FormList.find(item => item.name === i.conditionValue.split('_custom')[0])
                        if (typeObj && typeObj.datatype === 'custom') {
                            paramsLists.push({ name: typeObj.name, value: i.value })
                        }
                    }
                } else {
                    if (item.link !== 3) {
                        const typeI = i.FormList.findIndex(its => {
                            return its.name === i.conditionValue || `${its.name}_${its.type2}` === i.conditionValue
                        })
                        if (typeI !== -1) {
                            const typeObj = i.FormList[typeI]
                            const type = typeObj.type === 'Sizer' ? typeObj.i : typeObj.title + '_' + typeObj.type
                            const data = (i.value ? i.value : val) || ''
                            if (typeObj.datatype === 'custom') {
                                paramsLists.push({ name: typeObj.name, value: data })
                            } else {
                                obs[type] = data
                            }
                        }
                    }
                }
            }
            return { obs, paramsLists }
        },
        // 获取文件解析内容
        async getfileCont(file) {
            const resFile = await getfilecontent({
                path: file
            })
            if (resFile.code === 0) {
                return resFile.data
            }
            else{
                this.$message.error(resFile.msg)
                return false
            }
        },
        getDetailed() {

        },
        // 根据配置查询 本表和自定义 数据
        async getField(item, type) {
            console.log('当前要跳转的', item, type)
            let goObj = {
                url: item.url
            }
            switch (item.link) {
                case 1:
                    goObj = {
                        ...goObj,
                        url: '/clientSide/instrument/instrument',
                        dataReportId: this.$route.query.dataReportId,
                        showId: item.id
                    }
                    break
                case 2:
                    if (type === 'detailed') {
                        // 5 是 仪表盘的
                        if (item.datatype === 5) {
                            goObj = {
                                ...goObj,
                                url: '/clientSide/instrument/instrument',
                                dataReportId: item.appid,
                                showSearch: true
                            }
                            if (item.open === 4) goObj.navShow = 'true'
                        } else {
                            goObj = {
                                ...goObj,
                                url: '/clientSide/application',
                                approvalId: item.appid,
                                iId: item.appIid,
                                source: 'user',
                                name: item.appName,
                                navShow: false
                            }
                            goObj[goAppId[item.appIid]] = item.appIid
                        }
                    } else {
                        goObj = {
                            ...goObj,
                            url: '/clientSide/application',
                            approvalId: item.appid,
                            source: 'user',
                            name: item.appName
                        }
                        if (item.open === 2 || item.open === 5) goObj.navShow = false
                    }
                    break
            }
            // 不是链接才去找配置，是链接直接计算值
            if (item.link === 1) {
                // 根据 id 找到对应所有配置
                const i = this.layout.findIndex(its => its.i === item.id)
                if (i !== -1) {
                    const datas = this.layout[i]
                    console.log('查找对应配置', datas)
                    const search = {}
                    // 当前规则只有表内组建才支持
                    if (datas.rules && datas.link === 1) {
                        //- 外置筛选组件的筛选规则
                        search.rules = datas.rules;
                    }
                    // 本表数据参数
                    if (datas.relevanceRules) {
                        //- 表单关联表单的筛选规则
                        search.relevanceRules = datas.relevanceRules;
                    }

                    if (search.rules || search.relevanceRules) {
                        goObj.search = search
                    }

                }
            } else if (item.link === 2) {
                // 应用的话单独配置
                console.log('应用的单独配置2', item, item.linked)
                if (this.cardUser && JSON.stringify(this.cardUser) !== '{}') item.value = { ...item.value, ...this.cardUser }
                let obs = {}
                const screenLinked = []
                const filedLinked = []
                const otherLinked = []
                for (const i of item.linked) {
                    if (i.orgName === 'screen') {
                        screenLinked.push(i)
                    } else if (i.orgName === 'filed' || i.orgName === undefined) {
                        filedLinked.push(i)
                    } else {
                        otherLinked.push(i)
                    }
                }
                if (otherLinked.length !== 0) {
                    const obj = getOtherLinked({ linked: otherLinked, currentOrg: this.currentOrg, currentUser: this.currentUser })
                    obs = { ...obs, ...obj }
                }
                console.log(filedLinked, screenLinked, 'filedLinked, screenLinked', otherLinked);
                
                if (screenLinked.length !== 0) {
                    const screens = (this.screenRef && this.screenRef.length > 0 ? this.screenRef : this.$refs.screenRef) || []
                    if (this.otherToolScreenRef && this.otherToolScreenRef.length > 0) {
                      screens.push(...this.otherToolScreenRef)
                    }
                    const currentOrg = this.currentOrg
                    const customData = this.customData
                    const obj = getInsideScreenParam({ screenLinked, screens, currentOrg, customData, orgList: this.orgList })
                    obs = { ...obs, ...obj }
                }
                let beforeTick = 0
                for (const i of filedLinked) {
                    let val = ''
                    if (i.datatype === 'custom') {
                        // 自定义的变量
                        val = getCustomVal(i)
                    } else {
                        val = item.value ? (item.value[filterSymbol(i.title)] || item.value[filterSymbol(i.name)]) : ''
                        // ai小易把匹配的字段都传入
                        if (item.channel && item.channel === 'ai' && item.value) {
                            const matchingRule = i.FormList.find(rule => rule.name === i.conditionValue);
                            val = item.value[filterSymbol(i.title + '_' + i.type)]
                            if (filterSymbol(i.title + '_' + i.type) === 'aiResult_text' && val && val.content) {
                                val = val.content
                            }
                            // 富文本控件把markdown转成html格式
                            if(filterSymbol(i.title + '_' + i.type) === 'aiResult_text' && matchingRule && matchingRule.type === 'richTextWid'){
                                val = markdownToHtml(val)
                            }
                            else if(filterSymbol(i.title + '_' + i.type) === 'aiResult_text' && matchingRule && matchingRule.type !== 'richTextWid'){
                                // 非富文本控件，去除markdown格式，转换为纯文本
                                val = markdownToText(val)
                            }
                            console.log("val--",val)
                        }
                    }

                    if (i.title === '申请人' && i.name === '申请人') {
                        val = [{
                            realname: val,
                            userId: item.value.userId
                        }]
                        // 不敢改以前的逻辑 只能判断错的情况下这样处理
                        const _val = item.value[filterSymbol(i.title || i.name)]
                        if (item.value.userId === undefined && Array.isArray(_val)) {
                            val = _val
                        }
                    }
                    if (i.type === 'relation-user' && val && typeof val === "string") {
                        if (item.channel && item.channel === 'ai') {
                            val = JSON.parse(val)
                        }
                        else {
                            val = ''
                        }
                        // 如果联系人数据是个字符串就置空
                        if (item.channel && item.channel === 'ai' && item.value) {
                            val = JSON.parse(item.value[filterSymbol(i.title + '_' + i.type)])
                        }
                    } else if (i.type === 'relation-user' && val && typeof val === "object") {
                        // 去发起直接回去整个结构，不特殊处理
                        if (item.appIid === 11 && item.datatype === 1) {
                            // TODO
                        } else {
                            const typeI = i.FormList.findIndex(its => {
                                return its.name === i.conditionValue || `${its.name}_${its.type2}` === i.conditionValue
                            })
                            const typeObj = i.FormList[typeI]

                            // 这里是没有的自定义那种指定输出内容的，所以全部直接匹配(选择对象是申请人表示是搜索的，其他的直接返回整个人员数据)
                            if (Array.isArray(val)) {
                                val = typeObj.title === '申请人' && typeObj.type === 'relation-user' ? val.map(its => its.realname || its.name).join('') : val
                            } else {
                                val = typeObj.title === '申请人' && typeObj.type === 'relation-user' ? val.realname : val
                            }
                        }
                    } else if (i.type === 'date') {
                        val = await this.getTime(val, i.format)
                    }
                    const typeI = i.FormList.findIndex(its => {
                        return its.name === i.conditionValue.split('_')[0]
                    })
                    const typeObj = i.FormList[typeI]
                    let type = typeObj.type === 'Sizer' ? typeObj.i : typeObj.title + '_' + typeObj.type
                    if (typeObj.fatherType && typeObj.fatherType.includes('details')) {
                        type = `${type}--${typeObj.name}`
                    }
                    // 如果原来值存在的话，就判断格式转成数组，是数组的话则直接添加
                    if (typeObj.fatherType && typeObj.fatherType.includes('ready-widget')) {
                        const parentType = typeObj.fatherType.split('.')[0]
                        let obj = {}
                        const timeType = typeObj.timeType || 'start'
                        if (typeObj.type === 'dates' && i.type === 'date') {
                            const formItem = i.FormList.find(its => its.type === 'displaylist')
                            const type = `${typeObj.title}_${typeObj.type}`
                            const [day, time] = val.split(' ')
                            const timeArr = TIME_10_30_60[typeObj.tick || 30]
                            let timeIndex = timeArr.findIndex(its => its === time)
                            if (timeIndex > 0) {
                                timeIndex--
                            }
                            const displayListKey = `${formItem.title}_${formItem.type}`
                            if (obs[parentType]) {
                                obj = obs[parentType][0]
                                if (obj[type]) {
                                    obj[type].push(day)
                                } else {
                                    obj[type] = [day]
                                }
                                const isOnTheSameDay = obj[type].some(its => its === day)
                                if (isOnTheSameDay && obj[displayListKey]) {
                                    // 预约的是同一天
                                    if (obj[displayListKey][0].time.length === 1) {
                                        if (timeType === 'start') {
                                            obj[displayListKey][0].time[0] = timeIndex
                                        } else if (timeType === 'end') {
                                            obj[displayListKey][0].time[1] = timeIndex
                                        }
                                    }
                                } else if (obj[displayListKey]) {
                                    // 预约的是不同的一天
                                    const displayList = {
                                        tick: typeObj.tick || 30,
                                        date: day,
                                        time: []
                                    }
                                    if (timeType === 'start') {
                                        displayList.time[0] = timeIndex
                                    } else if (timeType === 'end') {
                                        displayList.time[1] = beforeTick
                                    }
                                    obj[displayListKey].push(displayList)
                                } else {
                                    obj[displayListKey] = [{
                                        tick: typeObj.tick || 30,
                                        date: day,
                                        time: [timeIndex]
                                    }]
                                }
                            } else {
                                // 没有预约控件值
                                obj[type] = [day]
                                obj[displayListKey] = [{
                                    tick: typeObj.tick || 30,
                                    date: day,
                                    time: []
                                }]
                                if (timeType === 'start') {
                                    obj[displayListKey][0].time[0] = timeIndex
                                } else if (timeType === 'end') {
                                    obj[displayListKey][0].time[1] = timeIndex
                                }
                                beforeTick = timeIndex
                            }
                        } else {
                            const type = `${typeObj.title}_${typeObj.type}`
                            if (obs[parentType]) {
                                obj = obs[parentType][0]
                            }
                            obj[type] = val
                        }
                        obs[parentType] = [obj]
                    } else {
                        if (obs[type]) {
                            if (Array.isArray(obs[type])) {
                                obs[type].push(val)
                            } else {
                                obs[type] = [obs[type], val]
                            }
                        } else {
                            if (!val && i.fatherType && i.fatherType.includes('details')) {
                                const it = i.fatherType.split('.')
                                if (item.value[it[0].split('_')[0]]) {
                                    val = typeof item.value[it[0].split('_')[0]] === 'string' ? JSON.parse(item.value[it[0].split('_')[0]])[0][`${i.title}_${i.type}`] : item.value[it[0].split('_')[0]][0][`${i.title}_${i.type}`]
                                }
                            }
                            obs[type] = val || ''
                        }
                    }
                }
                for (const i of item.customize) {
                    console.log('自定义遍历', i)
                    let val = item.value[i.title || i.name]
                    if (i.type === 'relation-user' && typeof val === "object") {
                        if (i.format === 'userId' || i.format === 'realname') {
                            val = val[i.format]
                        } else {
                            console.log('查询1', item.user, i.name)
                            if (Array.isArray(val)) {
                                val = []
                                for (const s of val) {
                                    const user = await this.getUserInfo(s.userId)
                                    val.push(user[i.format])
                                }
                            } else {
                                const user = await this.getUserInfo(val.userId)
                                val = user[i.format]
                            }
                        }
                    } else if (i.type === 'date') {
                        val = await this.getTime(val, i.format)
                    }
                    if (item.datatype === 5) {
                        // 仪表盘另外算
                        const types = i.FormList[i.index].i
                        if (obs[types]) {
                            const vals = Array.isArray(obs[types]) ? obs[types].push(val) : [obs[types], val]
                            obs[types] = vals
                        } else {
                            obs[types] = val
                        }
                    } else {
                        const typeI = i.FormList.findIndex(its => {
                            return its.name === i.conditionValue || `${its.name}_${its.type2}` === i.conditionValue
                        })
                        const typeObj = i.FormList[typeI]
                        let type = typeObj.type === 'Sizer' ? typeObj.i : typeObj.title + '_' + typeObj.type
                        // 传值是变量
                        if (typeObj && typeObj.datatype === 'custom' && item.datatype === 1) {
                            type = typeObj.name + '_' + typeObj.type + '_custom'
                        }
                        if (i.value) {
                            obs[type] = i.value || ''
                        } else {
                            obs[type] = val || ''
                        }
                    }
                }
                if (JSON.stringify(obs) !== '{}') {
                    const detailObj = {}
                    const detObs = {}
                    for (const key in obs) {
                        let end = item.linked.find(f => f.conditionValue === key.split('--')[1])
                        if (end) {
                            // 单独处理明细
                            const realname = end.conditionValue
                            const formList = end.FormList
                            const endItem = formList.find(item => item.name === realname)
                            if (endItem && endItem.fatherType) {
                                const endName = endItem.fatherType.split('.')
                                const endItemName = end.fatherType.split('.')
                                const [fatherItemTitle, fatherItemType] = endItemName[0].split('_')
                                const [fatherTitle, fatherType] = endName[0].split('_')
                                const [title, type] = endName[1].split('_')
                                const obj = {
                                    fatherTitle,
                                    fatherType,
                                    title,
                                    type,
                                    targetTitle: end.title,
                                    targetType: end.type,
                                    resTitle: end.title,
                                    resType: end.type,
                                    val: obs[key]
                                }
                                const fatherKey = `${fatherTitle}_${fatherType}`
                                if (detailObj[fatherKey] === undefined) {
                                    detailObj[fatherKey] = {
                                        type: `${fatherItemTitle}_${fatherItemType}`,
                                        val: [obj]
                                    }
                                } else {
                                    detailObj[fatherKey].val.push(obj)
                                }
                            }
                            delete obs[key]
                        }
                    }
                    for (const key in detailObj) {
                        let mapValue = item.detailValue || [item.value]
                        for (const cVal of mapValue) {
                            const val = cVal[detailObj[key].type.split('_')[0]]
                            const detail = detailObj[key]
                            if (val) {
                                try {
                                    let data = typeof val === 'string' ? JSON.parse(val) : val
                                    data = data.filter(f => !Array.isArray(f)).map(f => {
                                        const obj = {}
                                        detail.val.forEach(c => {
                                            let res = `${c.resTitle}_${c.resType}`
                                            const valRes = `${c.title}_${c.type}`
                                            if (c.val) {
                                                res = valRes
                                            }
                                            obj[res] = f[`${c.resTitle}_${c.resType}`] || c.val || f[valRes]
                                        })
                                        return obj
                                    })
                                    if (detObs[key]) {
                                        detObs[key].push(...data)
                                    } else {
                                        detObs[key] = data
                                    }
                                } catch (error) {
                                    const obj = {}
                                    detail.val.forEach(c => {
                                        obj[[`${c.title}_${c.type}`]] = cVal[c.targetTitle]
                                    })
                                    if (detObs[key]) {
                                        detObs[key].push(obj)
                                    } else {
                                        detObs[key] = [obj]
                                    }
                                }
                            }
                        }
                    }
                    goObj.search = {
                        ...obs,
                        ...detObs
                    }
                }
            } else {
                const obs = {}
                for (const i of item.customize) {
                    let val = item.value[i.title || i.name]
                    if (i.type === 'relation-user' && typeof val === "object") {
                        if (i.format === 'userId' || i.format === 'realname') {
                            val = val[i.format]
                        } else {
                            console.log('查询2', item.user, i.name)

                            const user = await this.getUserInfo(val.userId)
                            val = user[i.format]
                        }
                    } else if (i.type === 'date') {
                        val = await this.getTime(val, i.format)
                    }
                    if (i.parameter) {
                        obs[i.parameter] = val
                    } else {
                        obs[i.title + '_' + i.type] = val
                    }
                }
                if (JSON.stringify(obs) !== '{}') {
                    goObj = {
                        ...goObj,
                        ...obs
                    }
                }
            }
            return goObj
        },
        async getUserInfo(id) {
            const res = await apiGetmiddleuserbyid({ userId: id }).catch(err => { console.log(err) })
            if (res.code === 0) return res.data
        },
    }
}